<template>
  <component
    :is="getContainerType"
    v-if="shouldRenderConfig"
    :class="getClassName"
  >
    <appPacking3dBackward></appPacking3dBackward>
    <appPacking3dForward></appPacking3dForward>
  </component>
</template>
<script>
import { useBundleStore } from "@/stores/modules/bundle";
import { mapState, mapActions } from "pinia";

export default {
  props: ["hideContainer"]
};
</script>
